/*
 * The country-specific prescription fields for the medication modal.
 *
 * The medication form and tile are shared by both countries. Anything a country adds to a prescribed
 * item (AU: the PBS fields) goes through this service, so the shared code never checks the country
 * itself. NZ has no extra item fields yet, so it gets the no-op below.
 */
app.service("PrescriptionFieldsService", [
	"countryConfig",
	"AuPrescriptionFieldsService",
	function (countryConfig, AuPrescriptionFieldsService) {
		const NO_EXTRA_FIELDS = {
			isComplete: function () {
				return true;
			},
			fromForm: function () {
				return {};
			},
			reset: function () {},
			toPayload: function () {
				return {};
			},
			summary: function () {
				return "";
			},
		};

		return countryConfig.pbsPrescriptionFeatureEnabled ? AuPrescriptionFieldsService : NO_EXTRA_FIELDS;
	},
]);
